import React from 'react';
import { ChefHat, Search, Grid3X3, Heart, Smartphone, Video, Globe, Mail, Star, ExternalLink } from 'lucide-react';

function About() {
    return (
        <div className="about">
            <div className="container">
                {/* About Section */}
                <section className="about-section">
                    <div className="about-content">
                        <ChefHat className="page-icon" />
                        <h1>About Cooksy</h1>
                        <div className="about-text">
                            <p>
                                Welcome to <strong>Cooksy</strong>, your ultimate recipe discovery platform!
                                We're passionate about bringing you the best recipes from around the world,
                                making cooking fun, accessible, and delicious.
                            </p>

                            <p>
                                Whether you're a seasoned chef or just starting your culinary journey,
                                Cooksy helps you discover amazing recipes, save your favorites, and explore
                                cuisines from different cultures and categories.
                            </p>

                            <div className="features-list">
                                <h3>What makes Cooksy special?</h3>
                                <ul>
                                    <li><Search size={20} /> <strong>Smart Search:</strong> Find recipes instantly with our powerful search</li>
                                    <li><Grid3X3 size={20} /> <strong>Categories:</strong> Explore recipes by cuisine, meal type, and more</li>
                                    <li><Heart size={20} /> <strong>Favorites:</strong> Save and organize your favorite recipes</li>
                                    <li><Smartphone size={20} /> <strong>Responsive:</strong> Works perfectly on all your devices</li>
                                    <li><Video size={20} /> <strong>Video Tutorials:</strong> Learn with step-by-step video guides</li>
                                    <li><Globe size={20} /> <strong>Global Cuisine:</strong> Discover flavors from around the world</li>
                                </ul>
                            </div>

                            <div className="tech-stack">
                                <h3>Built with modern technology</h3>
                                <div className="tech-badges">
                                    <span className="tech-badge">React.js</span>
                                    <span className="tech-badge">CSS3</span>
                                    <span className="tech-badge">TheMealDB API</span>
                                    <span className="tech-badge">LocalStorage</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="about-image">
                        <div className="stats-card">
                            <h4>Recipe Statistics</h4>
                            <div className="stat">
                                <span className="stat-number">1000+</span>
                                <span className="stat-label">Recipes Available</span>
                            </div>
                            <div className="stat">
                                <span className="stat-number">20+</span>
                                <span className="stat-label">Categories</span>
                            </div>
                            <div className="stat">
                                <span className="stat-number">50+</span>
                                <span className="stat-label">Countries</span>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Contact Section */}
                <section className="contact-section">
                    <div className="contact-content">
                        <Mail className="section-icon" />
                        <h2>Get in Touch</h2>
                        <p>
                            Have questions, suggestions, or just want to share your cooking experience?
                            We'd love to hear from you!
                        </p>

                        <div className="contact-info">
                        
                            <div className="contact-item">
                                <Mail size={20} />
                                <h4>Email</h4>
                                <a
                                    href="mailto:iteshxt@gmail.com?subject=Hello%20from%20Cooksy%20User&body=Hi%20Itesh,%0D%0A%0D%0AI%20love%20using%20Cooksy!%20"
                                    className="contact-link"
                                >
                                    hello@example.com
                                </a>
                            </div>

                            <div className="contact-item">
                                <Star size={20} />
                                <h4>Feedback</h4>
                                <a
                                    href="https://www.iteshxt.me"
                                    className="contact-link"
                                >
                                    Share your thoughts
                                </a>
                            </div>
                        </div>

                        <div className="contact-form-note">
                            <p>
                                💡 <strong>Quick tip:</strong> Click any email link above to open your default email client
                                with a pre-filled message!
                            </p>
                        </div>
                    </div>
                </section>

                {/* Credits Section */}
                <section className="credits-section">
                    <div className="credits-content">
                        <h3>Credits & Attribution</h3>
                        <p>
                            Recipe data provided by <a
                                href="https://www.themealdb.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="external-link"
                            >
                                <ExternalLink size={16} />
                                TheMealDB
                            </a> - The Open Recipe Database
                        </p>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default About;